export { default as getGroupByFromViewMode } from './getGroupByFromViewMode';
